<template>
  <div class="min-h-screen bg-[#f6f7f9] py-10">
    <div class="max-w-[900px] mx-auto px-6">

      <div class="bg-white rounded-2xl border border-[#e9eaec] shadow-sm overflow-hidden">
        <div class="px-8 py-10">

          <nav class="flex items-center gap-2 text-[0.82rem] text-[#999] mb-6">
            <router-link to="/" class="hover:text-[#111] transition-colors no-underline"><i class="bi bi-house"></i></router-link>
            <i class="bi bi-chevron-right text-[0.7rem]"></i>
            <span class="text-[#111] font-medium">Over Ons</span>
          </nav>

          <div class="grid md:grid-cols-[1fr_190px] gap-6 md:gap-10 items-center mb-8">
            <div>
              <h1 class="text-[2rem] font-extrabold text-[#111] mb-4 leading-tight">Over Plug2Charge</h1>
              <p class="text-[1.0625rem] text-[#444] leading-relaxed mb-0">
                Plug2Charge is jouw specialist in zonnepanelen, laadpalen en thuisbatterijen. Wij geloven in een duurzame toekomst en helpen particulieren en bedrijven om stap voor stap energieonafhankelijk te worden.
              </p>
            </div>
            <img
              src="https://plug2charge.nl/wp-content/uploads/2026/07/thomas_batterij-removebg-preview.png"
              alt="Medewerker van Plug2Charge met een draagbare thuisbatterij"
              loading="lazy"
              width="425"
              height="586"
              class="hidden md:block w-full max-w-[190px] h-auto justify-self-end drop-shadow-md"
            />
          </div>

          <!-- USPs -->
          <div class="grid sm:grid-cols-3 gap-4 mb-8">
            <div class="rounded-xl bg-[#fffbe6] border border-[#FFD500]/30 p-5 flex flex-col items-start gap-3">
              <i class="bi bi-sun text-[#FFD500] text-[1.5rem]"></i>
              <h3 class="font-bold text-[#111] text-[0.9375rem]">Duurzame missie</h3>
              <p class="text-[0.8125rem] text-[#666]">We verkopen alleen producten die wij zelf zouden aanbevelen aan familie en vrienden.</p>
            </div>
            <div class="rounded-xl bg-[#fffbe6] border border-[#FFD500]/30 p-5 flex flex-col items-start gap-3">
              <i class="bi bi-people text-[#FFD500] text-[1.5rem]"></i>
              <h3 class="font-bold text-[#111] text-[0.9375rem]">Persoonlijk advies</h3>
              <p class="text-[0.8125rem] text-[#666]">Ons team staat klaar om je te helpen de beste keuze te maken voor jouw situatie.</p>
            </div>
            <div class="rounded-xl bg-[#fffbe6] border border-[#FFD500]/30 p-5 flex flex-col items-start gap-3">
              <i class="bi bi-shield-check text-[#FFD500] text-[1.5rem]"></i>
              <h3 class="font-bold text-[#111] text-[0.9375rem]">Kwaliteitsgarantie</h3>
              <p class="text-[0.8125rem] text-[#666]">Al onze producten hebben minimaal 2 jaar garantie. Zonnepanelen zelfs tot 25 jaar.</p>
            </div>
          </div>

          <h2 class="text-[1.25rem] font-bold text-[#111] mb-3 pb-2 border-b border-[#f0f0f0]">Ons verhaal</h2>
          <p class="text-[0.9375rem] text-[#444] leading-relaxed mb-4">
            Plug2Charge is opgericht vanuit de overtuiging dat schone energie voor iedereen bereikbaar moet zijn. We begonnen als kleine webshop voor balkonzonnepanelen en zijn uitgegroeid tot een compleet platform voor zonne-energie, laadpalen en thuisbatterijen.
          </p>
          <p class="text-[0.9375rem] text-[#444] leading-relaxed mb-6">
            We werken samen met de beste fabrikanten ter wereld, van LONGi en Trina Solar tot Alfen en Easee, zodat jij altijd de nieuwste en meest betrouwbare producten krijgt.
          </p>

          <h2 class="text-[1.25rem] font-bold text-[#111] mb-3 pb-2 border-b border-[#f0f0f0]">Onze belofte</h2>
          <ul class="flex flex-col gap-2 mb-6">
            <li v-for="p in promises" :key="p" class="flex items-center gap-3 text-[0.9375rem] text-[#444]">
              <i class="bi bi-check2-circle text-[#FFD500] text-[1rem] shrink-0"></i>
              {{ p }}
            </li>
          </ul>

          <div class="bg-[#f8f9fa] rounded-xl p-5 flex items-center gap-4">
            <i class="bi bi-envelope text-[#FFD500] text-[1.5rem] shrink-0"></i>
            <div>
              <p class="font-semibold text-[#111] mb-0.5">Neem contact op</p>
              <p class="text-[0.875rem] text-[#666] mb-0">Vragen? Mail naar <a href="mailto:info@plug2charge.nl" class="text-[#b8860b] no-underline hover:underline">info@plug2charge.nl</a> of <router-link to="/contact" class="text-[#b8860b] no-underline hover:underline">gebruik ons contactformulier</router-link>.</p>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
const promises = [
  'Gratis verzending vanaf €50, snel en betrouwbaar',
  '2 jaar garantie op alle producten, zonnepanelen tot 25 jaar',
  'Persoonlijk advies van echte energiespecialisten',
  '30 dagen bedenktijd. Niet tevreden? Geld terug.',
  'Veilig betalen via iDEAL, Creditcard, Klarna en meer',
]
</script>
